var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 565.215,
    height: 427.831,
    viewBox: "0 0 565.215 427.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 308.264,
    height: 502.555,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a42525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee0404"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "matrix(0.259, 0.966, -0.966, 0.259, 485.431, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M84.408,310.631l-1.315-30.557v.006l-8-181.453c17.946-6.4,30.028-20.4,29.094-41.607C103.4,39.266,93.676,20.614,79.577,9.238l1.665,37.55a9.9,9.9,0,0,1-4.56,8.77L57.447,67.831a9.9,9.9,0,0,1-9.882.436L27.326,57.746A9.9,9.9,0,0,1,22,49.406L20.345,11.862C7.31,24.436-.729,43.875.052,61.63c.94,21.2,14.215,34.084,32.658,38.872L41.1,290.688l.018.006.9,21.817A40.475,40.475,0,0,0,66.53,386.445c22.327-.989,39.572-22.813,38.583-45.14-.645-14.559-8.85-24.061-20.7-30.673M90.234,349.4l-8.069,15.524a9.047,9.047,0,0,1-7.615,4.861l-17.478.768a9.029,9.029,0,0,1-8.02-4.167l-9.409-14.75a9.037,9.037,0,0,1-.4-9.022L47.312,327.1a9.034,9.034,0,0,1,7.615-4.861l17.485-.774a9.039,9.039,0,0,1,8.014,4.167l9.409,14.75a9.049,9.049,0,0,1,.4,9.028",
    transform: "translate(-0.002 47.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M25.19,52.626a5,5,0,0,0,3.171,2.151L76.918,64.825A6.633,6.633,0,0,0,81.35,64.2l16.034-8.4a6.667,6.667,0,0,1,4.431-.621l12.113,2.507a1.878,1.878,0,0,0,2.219-1.457A78.742,78.742,0,0,1,120.824,33.6a1.93,1.93,0,0,0-.264-1.407,1.877,1.877,0,0,0-1.192-.805l-12.113-2.507a6.622,6.622,0,0,1-3.823-2.329L92.049,12.482a6.644,6.644,0,0,0-3.823-2.335L39.669.1a5.006,5.006,0,0,0-5.918,3.89,108.8,108.8,0,0,0-9.28,44.87,5.113,5.113,0,0,0,.719,3.761",
    transform: "translate(125.424 0.001)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M85.968,6.417,81.015,5.391a1.879,1.879,0,0,0-1.414.27A1.914,1.914,0,0,0,78.8,6.847,76.57,76.57,0,0,0,74.3,28.585a1.872,1.872,0,0,0,1.45,2.212l4.96,1.026a40.87,40.87,0,0,1,31.743,48.293L32.986,464.311a6.85,6.85,0,0,0,4.37,7.811A48.026,48.026,0,0,0,51.3,475a6.851,6.851,0,0,0,7.092-5.439L137.857,85.371A66.807,66.807,0,0,0,85.968,6.417",
    transform: "translate(169.006 27.539)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M89,228.092l-.43-3.257L72.108,100.273a37.706,37.706,0,0,0-9.643-67.806,1.89,1.89,0,0,0-2.292,2.507l8.579,21.793a13.162,13.162,0,0,1-1.942,12.98l-4.9,6.152A13.72,13.72,0,0,1,49.148,80.92l-7.774-1.168A13.127,13.127,0,0,1,31.11,71.579L22.53,49.78a1.885,1.885,0,0,0-3.38-.27,37.738,37.738,0,0,0,23.071,55.607l16.55,123.793.553,4a37.708,37.708,0,0,0,9.637,67.806,1.887,1.887,0,0,0,2.3-2.5l-8.579-21.8a13.132,13.132,0,0,1,1.948-12.98l4.892-6.152a13.725,13.725,0,0,1,12.759-5.021l7.774,1.168a13.136,13.136,0,0,1,10.27,8.174l8.573,21.8a1.892,1.892,0,0,0,3.386.27A37.644,37.644,0,0,0,89,228.092",
    transform: "translate(71.813 166.65)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.f03aa6adc8a14ce8083b754e9a2cc6bf.svg";
export { ForwardRef as ReactComponent };